<template>
  <div :class="$style['header-wrapper']">
    <div v-show="showSurveyBanner" :class="$style['survey-banner']" @click="goToSurvey">
      <div :class="$style['survey-banner-content']">
        <div :class="$style['survey-banner-content-text']">
          Gewinnen Sie ein iPad Air 11" und nehmen Sie an unserer Umfrage zur aktuellen Kundenzufriedenheit teil.
        </div>
        <BaseButton :class="$style['survey-banner-content-btn']" ghost-button>
          Zum Gewinnspiel
        </BaseButton>
        <img :class="$style['survey-banner-content-img']" src="@/base/assets/illustrations/iphone.png" alt="iphone">
        <button :class="$style['survey-banner-close-btn']" @click.stop="closeSurveyBanner">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
          >
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    </div>
    <header :class="$style.header">
      <div :class="$style.layout">
        <img
          alt="Logo"
          src="@/base/assets/logos/header-logo.svg"
          :class="$style.logoSmall"
        ><img
          alt="Logo"
          src="@/base/assets/logos/header-logo-l.svg"
          :class="$style.logoLarge"
        >
      </div>
    </header>
  </div>
</template>

<script setup lang="ts">

const surveyUrl = useRuntimeConfig().public.surveyUrl

const showSurveyBanner = ref(false)

const goToSurvey = () => {
  console.log('clicked')
  window.open(surveyUrl, '_blank')
}

const closeSurveyBanner = () => {
  showSurveyBanner.value = false
}
</script>

<style module>
.header-wrapper {
  z-index: 20;
  position: sticky;
  top: 0;
}

.survey-banner {
  cursor: pointer;
  position: relative;
  height: 100px;
  background: linear-gradient(to right, #00A4B8, #004952);
}

.survey-banner-close-btn {
  border: none;
  cursor: pointer;
  svg {
    width: 24px;
    height: 24px;
    stroke: var( --color-white);
  }
  @media screen and (min-width: 740px) {
      position: absolute;
      right: 0rem;
      padding: 1rem;
    }
}

.survey-banner-content {
  height: 100%;
  margin: 0 auto;
  display: flex;
  gap: 1rem;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  @media screen and (min-width: 740px) {
    max-width: 648px;
    padding: 0;
  }
}

.survey-banner-content-text {
    font-size: 0.8rem;
    line-height: normal;
    flex-shrink: 1;
    color: var(--color-white);

    @media screen and (min-width: 740px) {
      flex-shrink: 1;
      line-height: normal;
      font-size: 0.9rem;
    }
}

.survey-banner-content-btn {
  padding: 12px 12px;
  border: none;
  border-radius: 6px;
}

.survey-banner-content-logo,
.survey-banner-content-img {
  display: none;
  @media screen and (min-width: 1280px) {
    display: block;
  }
}

.survey-banner-content-img {
  position: absolute;
  right: calc((100vw - 648px)/4 - (279px)/2);
  height: 100%;
  opacity: 100%;
}

.header {
  width: 100%;
  background: var(--color-white);
  padding: 16px 25px 17px 25px;
  height: var(--layout-header-height-mobile);
  box-shadow: 0px 2px 8px 0px #0000001a;
  display: flex;
  flex-direction: column;;

  @media screen and (min-width: 740px) {
    height: var(--layout-header-height-desktop);
    padding: 26px 50px 26px 50px;
  }

  @media screen and (min-width: 1280px) {
    padding: 26px 100px;
  }
}

.layout {
  display: flex;
  width: 100%;
  max-width: 1440px;
  padding: 0;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-end;
  margin: 0 auto;

  @media screen and (min-width: 740px) {
    justify-content: center;
  }
}

.logoSmall {
  width: auto;
  height: 35px;

  @media screen and (min-width: 740px) {
    display: none
  }
}

.logoLarge {
  display: none;

  @media screen and (min-width: 740px) {
    display: block;
    width: auto;
    height: 68px;
  }
}
</style>
